import React ,{useState , useEffect} from 'react';
import CustomLines from '../home/customLines';
import CustomBigText from '../sharedComponents/customBigText';
import CustomBlockCard from './customBlockCards';
import ImageBlockOne from '../../assets/images/blockOne_1.png';
import ImageBlockTwo from '../../assets/images/blockTwo_1.png';
import ImageBlockedThree from '../../assets/images/blockThree_1.png';
import ImageBlockedFour from '../../assets/images/blockFour_1.png';
import ImageBlockedFive from '../../assets/images/blockFive_1.png';
import ImageBlockedSix from '../../assets/images/blockSix_1.png';
import { useTranslation } from 'react-i18next';
import useLanguageDirection from '../../hooks/useLanguageDirection';
const BlockedItemsSection =()=>{
   const {t} = useTranslation();
   const direction = useLanguageDirection();
       
    return (
      <div className='' dir={direction}>
         <div className="flex flex-col items-center justify-center text-center max-container">
         <CustomLines />
            <div className=''>
            <CustomBigText title={t('customBigText.prohibitedItems')} />
               
            </div>
               <div className='grid items-start justify-center w-full grid-cols-2 gap-3 my-10 md:px-10 md:gap-6 lg:grid-cols-6 sm:grid-cols-3'>
                  <div className=''>
                     <CustomBlockCard
                     image={ImageBlockedSix}
                     title={t('blockedItems.allLiquids')}
                     /></div>
                  
                  <div className=''>
                  <CustomBlockCard
                     image={ImageBlockedThree}
                     title={t('blockedItems.batteries')}
                     />
                  </div>
                  <div className=''>
                  <CustomBlockCard
                     image={ImageBlockedFour}
                     title={t('blockedItems.fakeBrands')}
                     />
                  </div>
                  <div className=''>
                  <CustomBlockCard
                     image={ImageBlockOne}

                     title={t('blockedItems.medicalSupplies')}
                     />
                  </div>
                  <div className=''>
                  <CustomBlockCard
                     image={ImageBlockTwo}
                     title={t('blockedItems.preciousMaterials')}
                     />
                  </div>
                  
                  <div className=''>
                  <CustomBlockCard
                     image={ImageBlockedFive}
                     title={t('blockedItems.weaponsAndExplosives')}
                     />
                  </div>    
               </div>

            </div>
      </div>
    )
}

export default BlockedItemsSection;